import axios from "functions/axios";

export const ListStaffsAPI = ({ page = 1, page_size = 15, search = "" } = {}) =>
  axios
    .get("admin/staffs/list/", {
      params: { page, page_size, search },
    })
    .then((res) => res.data);

export const ListAllStaffsAPI = ({ search = "" } = {}) =>
  axios
    .get("admin/staffs/all/", {
      params: { search },
    })
    .then((res) => res.data);

export const DeleteStaffsAPI = (pk) =>
  axios.delete(`admin/staffs/update_detele_role/${pk}/`).then((res) => res.data);

export const UpdateStaffsAPI = ({ pk, data }) =>
  axios.put(`admin/staffs/update_detele_role/${pk}/`, data).then((res) => res.data);

export const CreateStaffsAPI = ({ user, role, faculties, fields = null }) =>
  axios
    .post("admin/staffs/create_role/", {
      user,
      role,
      faculties,
      fields,
    })
    .then((res) => res.data);
